export default "__VITE_ASSET__$U0u3bqR__"